import { Component, h, ComponentInterface, Prop, Element, State } from '@stencil/core';
import { getQueryStringValue, guid, _BREAKPOINTS_ } from 'utils';


@Component({
    tag: 'kdx-sitefinity-search',
    styleUrl: 'kdx-sitefinity-search.scss',
    shadow: false
})
export class KdxSitefinitySearch implements ComponentInterface {

    @Element() root: HTMLElement;
    @State() guid: string = guid();

    @Prop() resultsUrl: string;
    @Prop() indexCatalogue: string;
    @Prop() wordsMode: string;
    @Prop() label: string;
    @Prop() placeholder: string;
    @Prop() searchId: string = `site-search`;
    @Prop() searchCategories: string = '';
    @Prop() cssClasses: string = '';
    searchCategoryArray: Array<any> = [];

    private selectedIndex = '';

    componentWillLoad() {
        if (this.searchCategories !== '') {
            this.searchCategoryArray = JSON.parse(this.searchCategories);
            this.selectedIndex = this.searchCategoryArray[0].IndexName;
        } else {
            this.selectedIndex = this.indexCatalogue;
        }
    }

    public searchValue: string;

    componentDidRender() {
        const searchTermQs = getQueryStringValue('searchQuery');

        if (searchTermQs && searchTermQs != '') {
            const searchInput: HTMLInputElement = this.root.querySelector('input.form-control');
            searchInput.value = searchTermQs;
            this.searchValue = searchTermQs;
        }

        const mobilesearch = document.querySelector('.mobile-bottom-nav .mobile-control .search') as HTMLAnchorElement;
        const searchElements = this.root.querySelector('form.kdx-site-search')
        mobilesearch.addEventListener('click', (e) => {
            this.closeNav();
            e.preventDefault();
            searchElements.classList.toggle('show')
            mobilesearch.classList.toggle('open')
        })
    }

    searchSubmit(e) {
        e.preventDefault();
        const category = this.root.querySelector('select.search-categories') as HTMLSelectElement
        var term = this.searchValue;
        var qs = `?indexCatalogue=${this.selectedIndex}&searchQuery=` + encodeURIComponent(term) + `&wordsMode=${this.wordsMode}` + `&category=${category ? category.value : 'All'}`;
        window.location.href = this.resultsUrl + qs;
    }

    closeNav() {
        const mobileMenu = document.querySelector('.mobile-bottom-nav .mobile-control .menu') as HTMLAnchorElement;
        const navMenuItems = document.querySelector('.app-nav')
        mobileMenu.classList.remove('open')
        navMenuItems.classList.remove('show')
    }

    updateIndex() {
        const menu: HTMLSelectElement = this.root.querySelector('.search-categories');

        if (menu) {
            this.selectedIndex = menu.value;
        }
    }

    render() {
        return (
            <form
                class={`kdx-site-search ${this.cssClasses}`}
                onSubmit={(e) => { this.searchSubmit(e) }}>
                <div class="container">
                    <span>SEARCH</span>
                    {this.searchCategoryArray?.length > 0 &&
                        <select class='form-select search-categories' onChange={() => {this.updateIndex()}}>
                            {this.searchCategoryArray.map((searchCategory) => (
                                <option value={searchCategory.IndexName}>{searchCategory.Label}</option>
                            ))}
                        </select>
                    }
                    <div class="input-container">
                        <input
                            type="text"
                            class={`form-control ${!this.searchCategoryArray || this.searchCategoryArray.length === 0 ? 'no-categories' : ''}`}
                            required={true}
                            id={this.searchId}
                            placeholder={this.placeholder}
                            onKeyUp={(e: KeyboardEvent) => this.searchValue = (e.target as HTMLInputElement).value} />
                        <button type="submit" class="input-group-text svg-icon" id={`site-search-icon-${this.searchId}`} aria-label="Submit Search">
                            <kdx-icon icon="search-icon"></kdx-icon>
                        </button>
                    </div>
                </div>


            </form>
        );
    }
}